/* eslint-disable max-len */
import { useTranslate } from "react-admin";
import * as User from "../../providers/user";

const DashboardRoleArtistServices = ({ data }: { data: any }) => {
  const { permissions } = User.useUser();
  const translate = useTranslate();

  if (!permissions?.companyId) return null;

  return (
    <div className="w-full h-full">
      <div
        className="w-full h-[52px] bg-[#FAF9F7] rounded-t-lg grid grid-cols-8 border-b border-[rgba(224,224,224,1)] 
      text-[14px] leading-[20.02px] font-[400] text-mono-primaryTextColor"
      >
        <div className="col-span-5 w-full h-full flex items-center pl-4 pr-2">
          {translate("dashboard.service")}
        </div>
        <div className="col-span-2 w-full h-full flex items-center justify-end pl-2 pr-6">
          {translate("dashboard.completed")}
        </div>
        <div className="col-span-1 w-full h-full flex items-center justify-end pl-2 pr-4">
          {translate("dashboard.total")}
        </div>
      </div>

      <div className="w-full h-[calc(100%-51px)] overflow-y-auto text-[14px] leading-[20.02px] rounded-lg font-[400] text-mono-primaryTextColor">
        {data?.servicesByArtist?.length === 0 && (
          <div className="w-full h-[200px] bg-[#FAF9F7] flex justify-center items-center rounded-b-lg">
            {translate("dashboard.no_data_yet")}
          </div>
        )}
        {data?.servicesByArtist?.map((service: any) => (
          <div
            key={service?.service_id}
            className="w-full h-[52px] grid grid-cols-8 bg-[#FAF9F7] last:rounded-b-lg"
          >
            <div className="col-span-5 w-full h-full flex gap-[6px] items-center pl-4 pr-2">
              <span className="line-clamp-1 break-all">
                {service?.service_name}
              </span>
            </div>
            <div className="col-span-2 w-full h-full flex items-center px-2 justify-end pr-6">
              {service?.completed}
            </div>
            <div className="col-span-1 w-full h-full flex items-center justify-end pr-4">
              {service?.total}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardRoleArtistServices;
